module.exports = __webpack_public_path__ + "assets/img/returnBtn-56fc6e84.png";